import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { parseDateValue } from "../../classes/utils/DateUtils";
import { GET_QUALITY_OF_LIFE_INDICATORS_BY_IDS } from "../../queries/qualityOfLifeIndicatorQueries";

export function useQualityOfLifeIndicatorsData(indicatorIds) {
  const uniqueIds = useMemo(() => {
    if (!indicatorIds?.length) return [];
    return Array.from(new Set(indicatorIds.filter(Boolean)));
  }, [indicatorIds]);

  const { data, loading, error, refetch } = useQuery(
    GET_QUALITY_OF_LIFE_INDICATORS_BY_IDS,
    {
      variables: { ids: uniqueIds },
      skip: !uniqueIds.length,
      fetchPolicy: "network-only",
    }
  );

  const qualityOfLifeIndicators = useMemo(
    () => data?.qualityOfLifeIndicatorsByIds || [],
    [data]
  );

  const indicatorsByDate = useMemo(() => {
    return [...qualityOfLifeIndicators].sort(
      (a, b) =>
        (parseDateValue(b.date || b.createdAt)?.getTime() ?? 0) -
        (parseDateValue(a.date || a.createdAt)?.getTime() ?? 0)
    );
  }, [qualityOfLifeIndicators]);

  const latestQualityOfLifeIndicator = useMemo(
    () => indicatorsByDate[0] || null,
    [indicatorsByDate]
  );

  return {
    qualityOfLifeIndicators,
    indicatorsByDate,
    latestQualityOfLifeIndicator,
    loading,
    error,
    refreshQualityOfLifeIndicators: refetch,
  };
}
